import { HttpErrorResponse } from '@angular/common/http';
import { AllProductService } from './../../../../services/shared/product-settings/all-products.service';
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CatalogService } from 'src/app/services/shared/catalog.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-catalogs',
  templateUrl: './catalogs.component.html',
  styleUrls: ['./catalogs.component.scss']
})
export class CatalogsComponent {
  @Input() data: any;
  @Input() filterColumns: any;
  itemsPerPage = 12;
  products: any[] = [];
  originalData: any[] = [];
  showNoRecordsFounds = false;
  newData: any[] = [];
  isLogin: any;
  @Input() brandProfileProducts: any ='Catalogs';
  isCatalogSection: boolean = true;
  catalogData: any[] = [];
  productInfoIds: any[] =[];
  constructor(
    private route: ActivatedRoute,
    private catalogService: CatalogService,
    private router: Router,
    private allProductService: AllProductService,
    private changeDetectionRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.isLogin = localStorage.getItem('accountName');
    if (this.router.url.includes('type=distributor')) {
      this.getCatalogByDistributorId(this.data.id);
      return;
    }
    this.getCatalogByOemId(this.data.id);
  }

  paginatedItems: { catalog: string; title: string; type: string }[] = [];

  getCatalogByDistributorId(id: string): void {
    this.catalogService.getDistributorCatalogs(id).subscribe({
      next: (response) => {
        if (response === null || response.data === null) {
          this.products = [];
        } else {
          this.newData = response.data.map((item: { catalog: string }) => ({
            ...item,
            type: this.getFileType(item.catalog),
          }));
          this.products = this.newData;          
          this.originalData = this.newData;
          this.paginatedItems = this.products.slice(0, this.itemsPerPage);
        }
        this.paginatedItems = this.products.slice(0, this.itemsPerPage);
       
      },

      error: (error) => {
      }
    });
  }

    accessDenied() {
      Swal.fire({
        title: 'Access Denied!',
        text: 'Please Login or SignUp',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    }

  pageNumber: any = 0;
  pageSize: any = 1000;
  contains : any = '';
  totalCount: any = 0;

  getCatalogByOemId(brandId: string): void {
    this.catalogService.getCatalogs(brandId).subscribe({
      next: (response) => {
        if (response === null || response.data === null) {
          this.products = [];
        } else {
          this.newData = response.data.map((item: { catalog: string }) => ({
            ...item,
            type: this.getFileType(item.catalog),
            // totalPagesCount: this.getTotalPagesCountInCatalogFile(item)
          }));
          this.products = this.newData;
          this.originalData = this.newData;
          this.totalCount = response.totalCount;
          this.newData.forEach((data: any)=> {
            this.getProductDetailsObject(data);
          });
          this.paginatedItems = this.products.slice(0, this.itemsPerPage);
        }
        this.paginatedItems = this.products.slice(0, this.itemsPerPage);
       
      },
      error: (error) => {
      }
    });
  }
  getProductDetailsObject(data: any) {
    const isProductDetailsNotEmpty = ((data?.productInfoId !== '' && data?.productInfoId !== null && data?.productInfoId !== undefined) 
    && (data?.productName !== '' && data?.productName !== null && data?.productName !== undefined))
    if(this.catalogData && this.catalogData.length !== 0 && isProductDetailsNotEmpty) {
       const existedProduct = this.catalogData.find((d: any) => {
        return d?.productName === data?.productName;
       })
        if(!existedProduct) {
          this.catalogData.push({
            productInfoId: data?.productInfoId,
            productName: data?.productName
          })
        }
    } else {
      if(isProductDetailsNotEmpty) {
        this.catalogData.push({
          productInfoId: data?.productInfoId,
          productName: data?.productName
        })
      }
    }
  }

  getFileType(url: string): string {
    const extension = url.split('.').pop();
    switch (extension) {
      case 'pdf':
        return 'pdf';
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return 'image';
      default:
        return 'unknown';
    }
  }

  onPageChanged(paginatedData: any[]): void {
    this.paginatedItems = paginatedData;
  }

  filteredData = this.products;

  onFilteredData(filtered: any[]): void {
  
    
    this.filteredData = filtered;
    this.products = filtered;
    this.paginatedItems = this.filteredData.slice(0, this.itemsPerPage);
    if (this.paginatedItems.length === 0) {
      this.showNoRecordsFounds = true;
    } else {
      this.showNoRecordsFounds = false;
    }
  }

  viewCatalog(catalog: any): void {
    if(!this.isLogin) {
      this.accessDenied();
      return;
    }
    const url = `${catalog.catalog}?title=${encodeURIComponent(catalog.name)}`;
    window.open(url, '_blank');
  }
  

  downloadCatalog(file: any) {
    if(!this.isLogin) {
      this.accessDenied();
      return;
    }
    if (!file) {
      return;
    }
    const name = file?.name?.toLowerCase() || file?.productName?.toLowerCase() || 'default-name';
    const url = file?.url || file?.catalog;
    if (!url) {
      return;
    }
    this.allProductService.downloadFile(url, name).subscribe(
      (blob: Blob) => {
        
        this.allProductService.saveFile(blob, name);
      },
      (error) => {
      }
    );
  }
  sanitizeUrl(url: string): void {
    if (!url) {
      return;
    }
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  }
  
  getFilteredProductListIds(event: any) {
    this.productInfoIds = event || [];
    this.getCatalogByOemIdWithProductInfoIds(this.data.id)
  }

  getCatalogByOemIdWithProductInfoIds(brandId: string): void {
    let data = {}
    if(this.productInfoIds && this.productInfoIds.length > 0) {
      data = {
        productInfoIds : this.productInfoIds || []
      }
    }
    
    this.catalogService.getCatalogsWithProductInfoIds(brandId, this.pageNumber, this.pageSize, this.contains, data).subscribe({
      next: (response) => {
        if (response === null || response.data === null) {
          this.products = [];
          this.totalCount = 0;
          this.originalData = [];
          this.paginatedItems = [];
        } else {
          this.newData = response.data.map((item: { catalog: string }) => ({
            ...item,
            type: this.getFileType(item.catalog),
          }));
          this.products = this.newData;
          this.totalCount = response.totalCount;
          this.originalData = this.newData;
          this.paginatedItems = this.products.slice(0, this.pageSize);
        }
      },
      error: (error) => {
        this.products = [];
        this.totalCount = 0;
        this.originalData = [];
        this.paginatedItems = [];
      },
      complete: () => {
        this.changeDetectionRef.detectChanges();
      }
    });
  }

  getFormattedName(name: any): any {
    if(!name) return '';
    return name?.split('.')?.slice(0, -1)!.join('.')!.replace(/^[^_]+_/, '');
  }
}